import { Observable } from 'rxjs';

import { Container, Service, StorageService } from '../../../symphony';
import { SlStorageKeys } from '../../../shared/public/globalInterfaces/globalInterfaces';
import {
	CodeApi, DefaultCodeLanguages, ICodeAPI, ICodeCompilationResponse, ICodeCompilePayload, ICodeDefaultResponse, IUserCodePayload, IUserCodeResponse,
} from '../../../api/public/code-api';
import {
	ILearnEngineApi, IMaterialInfo, ISolveMaterialPayload, ISolveMaterialDTO,
} from '../../../api/private/learn-engine-api/learn-engine-api.interface';
import { LearnEngineApi } from '../../../api/public/learn-engine/learn-engine-api';

@Service()
export class SlApiService {
	private codeApi: ICodeAPI;

	private learnEngineApi: ILearnEngineApi;

	private storageService = Container.take('global', StorageService);

	constructor() {
		this.codeApi = new CodeApi();
		this.learnEngineApi = Container.take('global', LearnEngineApi);
	}

	public getMaterial(materialId: number): Observable<IMaterialInfo> {
		return this.learnEngineApi.getMaterial(
			materialId,
			this.storageService.load(SlStorageKeys.Sl_LE_SESSION, 'session'),
		);
	}

	public solveMaterial(
		payload: ISolveMaterialPayload,
	): Observable<ISolveMaterialDTO> {
		return this.learnEngineApi.solveMaterial(
			payload,
			this.storageService.load(SlStorageKeys.Sl_LE_SESSION, 'session'),
		);
	}

	public getUserCode(id: string): Observable<IUserCodeResponse> {
		return this.codeApi.getUserCode(id);
	}

	public getDefaultCode(
		id: DefaultCodeLanguages,
	): Observable<ICodeDefaultResponse> {
		return this.codeApi.getDefaultCode(id);
	}

	public saveUserCode(data: IUserCodePayload): Observable<IUserCodeResponse> {
		return this.codeApi.saveUserCode(data);
	}

	public publishCode(data: IUserCodePayload): Observable<IUserCodeResponse> {
		return this.codeApi.saveUserCode(data);
	}

	public compileCode(
		data: ICodeCompilePayload,
	): Observable<ICodeCompilationResponse> {
		return this.codeApi.compileCode(data);
	}
}
